import ZVVDto from "./ZVVDto";

export default class ZVVEinladungDto {

  static ACCEPTED = 'ACCEPTED'
  static ARCHIVED = 'ARCHIVED'

  constructor(json) {
    this.id = json.id
    this.zvv = new ZVVDto(json.zvv)
    this.createdAt = json.createdAt
    this.gpIdVnb = json.gpIdVnb
    this.validUntil = json.validUntil
    this.archivedAt = json.archivedAt
  }

  get name() {
    return this.zvv.name
  }

  get invitedBy() {
    return this.zvv.geschaeftspartner.name
  }
}
